import React, { useState, useEffect } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import {
  getCuentaGastos,
  deleteCuentaGasto,
  putCuentaGasto,
} from "../helpers/rutaCuentaGastos";
import "../css/tableclientes.css";

const TableCuentaGastos = () => {
  const [cuentasgasto, setCuentasgasto] = useState({ data: [], loading: true });

  const [editShow, setEditShow] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editCuenta, setEditCuenta] = useState("");

  useEffect(() => {
    consultaCuentasGasto();
  }, []);

  const consultaCuentasGasto = () => {
    getCuentaGastos()
      .then((datos) => {
        const lista = Array.isArray(datos)
          ? datos
          : datos?.cuentagastos || [];
        setCuentasgasto({ data: lista, loading: false });
      })
      .catch((err) => {
        console.error("Error al consultar cuentas de gasto:", err);
        setCuentasgasto({ data: [], loading: false });
      });
  };

  const abrirEditor = (item) => {
    setEditItem(item);
    setEditCuenta(item?.cuentagasto || "");
    setEditShow(true);
  };

  const cerrarEditor = () => {
    setEditShow(false);
    setEditItem(null);
    setEditCuenta("");
  };

  const guardarEditor = async (e) => {
    e.preventDefault();
    if (!editItem?._id) return;

    const cuentagasto = String(editCuenta || "").trim();
    if (!cuentagasto) return;

    const resp = await putCuentaGasto(editItem._id, {
      cuentagasto,
      activo: !!editItem.activo,
    });

    if (resp?.ok === false) {
      alert("Error al guardar");
      return;
    }

    cerrarEditor();
    consultaCuentasGasto();
  };

  const eliminarCuenta = (id) => {
    const confirmar = window.confirm(
      "¿Está seguro que desea borrar la cuenta de gasto?"
    );
    if (confirmar) {
      deleteCuentaGasto(id).then(() => consultaCuentasGasto());
    }
  };

  return (
    <div className="table-container">
      {!cuentasgasto.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Cuenta</th>
                </tr>
              </thead>

              <tbody>
                {cuentasgasto.data.map((item) =>
                  item.activo ? (
                    <tr key={item._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => abrirEditor(item)}
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                          />
                        </button>

                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarCuenta(item._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>

                      <td>{item.codcga}</td>
                      <td>{item.cuentagasto}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <Modal show={editShow} onHide={cerrarEditor}>
            <form onSubmit={guardarEditor}>
              <Modal.Header closeButton>
                <Modal.Title>Modificar Cuenta de Gasto</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div className="form-group mt-2">
                  <label>Cuenta</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editCuenta}
                    onChange={(e) => setEditCuenta(e.target.value)}
                    required
                  />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={cerrarEditor}>
                  Cancelar
                </Button>
                <Button type="submit" variant="dark">
                  Guardar
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </>
      )}
    </div>
  );
};

export default TableCuentaGastos;